<div class="card-header">
  <div class="headerRow">
    <nz-icon nzType="info-circle" class="header-icon" />
    <span><strong>{{'jsoncomponent.selectedConfig'|translateTA}}</strong>
      {{ configHeader || ('jsoncomponent.selectConfigHint'|translateTA) }}</span>
  </div>

  <div class="header-controls">
    <div class="tem-field header-field" *ngIf="uas.user.companylist.length > 1">
      <span class="tem-field-label">{{'jsoncomponent.chooseCompany'|translateTA}}</span>
      <nz-select [(ngModel)]="codecompany" (ngModelChange)="getActiveCompanies()" nzShowSearch
        [nzPlaceHolder]="'jsoncomponent.chooseCompany'|translateTA">
        <nz-option *ngFor="let data of uas.user.companylist" [nzValue]="data.codecompany"
          [nzLabel]="data.codecompany + ' - ' + data.companyname"></nz-option>
      </nz-select>
    </div>

    <div class="tem-field header-field">
      <span class="tem-field-label">{{'jsoncomponent.visibility'|translateTA}}</span>
      <nz-select [(ngModel)]="configVisibility" [nzPlaceHolder]="'jsoncomponent.visibility'|translateTA">
        <nz-option *ngFor="let opt of visibilityOptions" [nzValue]="opt.value"
          [nzLabel]="opt.label|translateTA"></nz-option>
      </nz-select>
    </div>

    <div class="header-buttons">
      <!-- Botao: Criar Nova Configuracao -->
      <button nz-button nzType="primary" type="button" (click)="openDPARAModal(false)">
        <nz-icon nzType="plus" />{{'jsoncomponent.newConfig'|translateTA}}
      </button>

      <!-- Botao: Editar Configuracao (so aparece se tiver uma selecionada) -->
      <button nz-button type="button" *ngIf="idRule" (click)="openDPARAModal(true)">
        <nz-icon nzType="edit" />{{'jsoncomponent.editConfig'|translateTA}}
      </button>
    </div>
  </div>
</div>

<div class="view-component">
  <nz-tabs class="custom-tabs" (nzSelectChange)="onTabChanged('Mktpjsonrule')">
    <nz-tab [nzTitle]="'jsoncomponent.tabConfigs'|translateTA">
      <div class="content">
        <simple-datagrid #datagridCfg entityName="Mktpjsonrule" [parentRow]="parentRow" [selectedRow]="selecteRow"
          [condition]="conditionCfg" [getCondition]="getConditionFunction"
          [events]="eventsSubject.asObservable()"></simple-datagrid>
      </div>
    </nz-tab>
  </nz-tabs>
</div>
